import {FCWithHTMLAttributes} from "../../types/reactTypes";
import clsMerge from "../../util/clsMerge";

const LoadingBox: FCWithHTMLAttributes = ({className}) => {
	return (
		<div
			className={clsMerge(
				"loading-gradient rounded-2xl bg-gray-300",
				className
			)}
		/>
	);
};

export default LoadingBox;
